import React, { Component, Fragment } from 'react'

import chevron from '../../assets/chevron-thin-down.svg'
import { Container, Button, MobileContainer, StyledSelect, Title } from './styles'

class Filter extends Component {
  render() {
    return (
      <Fragment>

        <Container>
          <Button active={this.props.filter === ''} onClick={this.props.handleClick} data-value={''}>
            Alle {this.props.product}
          </Button>
          {this.props.categories
            ? Object.keys(this.props.products).map((key, index) => {
                return (
                  <Button
                    active={this.props.filter === key}
                    key={index}
                    onClick={this.props.handleClick}
                    data-value={key}
                  >
                    {key}
                  </Button>
                )
              })
            : null}
        </Container>

        <MobileContainer>
          <Title>Sorteren op:</Title>
          
          <StyledSelect value={this.props.filter} onChange={this.props.handleSelectClick} chevron={chevron}>
            <option value=''>
              Alle {this.props.product}
            </option>

            {this.props.categories
            ? Object.keys(this.props.products).map((key, index) => {
                return (
                  <option
                    key={index}
                    value={key}
                  >
                    {key}
                  </option>
                )
              })
            : null}
          </StyledSelect> 
        </MobileContainer>

      </Fragment>
    )
  }
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/Filter/index.js